/**
 * 项目历史记录管理
 * 参考 project/src/history/projectsHistoryMap.ts
 */
import { IProject } from '../entities/IProject';
import { getProxyTarget, proxyUtils } from "@fanfanlo";
import _ from "lodash";

export interface IProjectHistory {
  index: number
  project: IProject
  date: string
}

export const projectsHistoryMap = new Map<string, IProjectHistory[]>()

export function addProjectHistory(history: IProjectHistory) {
  proxyUtils.runPauseProxyFn(() => {
    history.project = _.cloneDeep(getProxyTarget(history.project))
  })
  const p = history
  const projectId = history.project.ulid
  const list = projectsHistoryMap.get(projectId)
  if (!list) {
    projectsHistoryMap.set(projectId, [p])
    return
  }
  list.push(p)
}

export function getProjectHistory(projectId: string) {
  const result = projectsHistoryMap.get(projectId) || []
  return result
}

export function removeProjectHistory(projectId: string) {
  projectsHistoryMap.delete(projectId)
}

export function getProjectLastHistory(projectId: string) {
  const list = getProjectHistory(projectId)
  const result = list[list.length - 1]
  return result
}

export function takeProjectSnapshoot(project: IProject): boolean {
  const last = getProjectLastHistory(project.ulid)
  if (last && _.isEqual(last.project, project)) {
    return false
  }
  const newIndex = last ? last.index + 1 : 0
  addProjectHistory({
    index: newIndex,
    project,
    date: new Date().toISOString()
  })
  return true
}

export function projectHistoryIsChanged(project: IProject): boolean {
  const last = getProjectLastHistory(project.ulid)
  const isChanged = !last || !_.isEqual(last.project, project)
  return isChanged
}

export function isSameProjectHistoryId(id: number, projectId: string): boolean {
  const last = getProjectLastHistory(projectId)
  const isSame = last?.index === id
  return isSame
}
